/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module VsLogsModule
 */

import { Pipe, PipeTransform } from '@angular/core';

/**
 * @description
 *     Pipe for add a prefix to a HTTP version string.
 * @author Zhiqian Liu
 */
@Pipe({
    name: 'logHttpVersion',
})
export class LogHttpVersionPipe implements PipeTransform {
    /** @override */
    // eslint-disable-next-line class-methods-use-this
    public transform(version: string): string {
        if (!version) {
            return '';
        }

        return `HTTP/${version}`;
    }
}
